// auto-generated by Typewriter template _models.tst from PortCall.Pilots.EndPoints\App\RotationDashboard\RotationDashboardViewModel.cs
import S, { DataSignal } from 's-js';
import SArray, { SDataArray } from 's-array';
import TZDate from 'lib/TZDate';
import { jsonableObservable } from 'lib/jsonableObservable';
import { Pilot, PilotData, PilotOptions } from 'data/models/Pilot';
import { PilotAgency, PilotAgencyData, PilotAgencyOptions } from 'data/models/PilotAgency';
import { PilotsNavbar, PilotsNavbarData, PilotsNavbarOptions } from 'data/models/PilotsNavbar';

// RotationDashboardData is the class that RotationDashboard serializes to/from
export interface RotationDashboardData {
    Id : number;
	
    Navbar : PilotsNavbarData | null;
    PilotAgency : PilotAgencyData | null;
    Pilots : PilotData[] | null;
	
    CanEdit : boolean;
}

// RotationDashboardOptions is the class which may be passed to the RotationDashboard constructor to define optional initial data values
export interface RotationDashboardOptions {
    Id : number;
	
    Navbar? : PilotsNavbarOptions | null;
    PilotAgency? : PilotAgencyOptions | null;
    Pilots? : PilotOptions[] | null;
	
    CanEdit? : boolean;
}

export class RotationDashboard {
    public Id : DataSignal<number>;
	
    public Navbar : DataSignal<PilotsNavbar | null>;
    public PilotAgency : DataSignal<PilotAgency | null>;
    public Pilots : SDataArray<Pilot>;
	
    public CanEdit : DataSignal<boolean>;

    constructor();
    constructor(data : RotationDashboardOptions);
    constructor(data: RotationDashboardOptions | null = null) {
        this.Id = jsonableObservable(S.value<number>(data && data.Id !== undefined ? data.Id : 0));
	    
        this.Navbar = S.value<PilotsNavbar | null>(null);
        this.PilotAgency = S.value<PilotAgency | null>(null);
        this.Pilots = SArray<Pilot>([]);
	    
        this.CanEdit = jsonableObservable(S.value<boolean>(data && data.CanEdit !== undefined ? data.CanEdit : false));
    }

    static key(obj : RotationDashboard) {
        return obj.Id();
    }
    
    static dataKey(obj : RotationDashboardOptions) {
        return obj.Id;
    }

    static update(obj : RotationDashboard, data : RotationDashboardOptions) {
        S.freeze(() => {
            if (data.Id !== undefined) obj.Id(data.Id);
	        
	        
            if (data.CanEdit !== undefined) obj.CanEdit(data.CanEdit);
        });
    }
}



// WEBPACK FOOTER //
// ./server/models/RotationDashboard.ts